// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"28723a8a248a797f2d8d","883":"57dcec8f597bd1b7df49"}[chunkId] + ".js";
};